<template>
  <validation-provider
    :rules="rules"
    :name="name"
    :vid="name"
    v-slot="validation"
    tag="div"
  >
    <div
      :class="{
        [$style.container]: true,
        [$style.invalid]: validation.valid === false,
        [$style.valid]: validation.valid === true
      }"
    >
      <label :class="$style.label">
        <input
          :class="$style.input"
          v-model="innerValue"
          :autofocus="autofocus"
          :disabled="disabled"
          type="checkbox"
          :name="name"
          :id="idFromName"
          ref="input"
        />
        {{ label }}
      </label>
      <div :class="$style.error">{{ validation.errors[0] }}</div>
    </div></validation-provider
  >
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { kebabCase } from 'lodash'

export default {
  name: 'base-checkbox',

  components: { ValidationProvider },

  props: {
    autofocus: { Boolean, default: false },
    disabled: { Boolean, default: false },
    label: { String, required: true },
    rules: { String },
    name: { String, required: true }
  },

  data: () => ({
    innerValue: null
  }),

  computed: {
    idFromName() {
      return kebabCase(this.name)
    }
  },

  watch: {
    innerValue(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" module>
.container {
  text-align: left;
}

.label {
  font-size: 15px;
  line-height: 1.5;
  display: block;
  position: relative;
  color: $color-copy;
  font-weight: $weight-regular;
  padding-left: spacing(3);
  cursor: pointer;
}

.input {
  position: absolute;
  left: 0;
  top: 2.5px;
  font-size: $size-medium;
  margin: 0;
}

.error {
  font-size: $size-xx-small;
  font-weight: $weight-medium;
  line-height: $size-medium;
  letter-spacing: 0.4px;
  color: $color-danger;
  min-height: spacing(2);
  margin-left: spacing(3);
  margin-top: 2px;
  text-align: left;
}
</style>
